import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { PERPETUAL } from '@/constants/durations'
import { durationText } from '@/utils/durationUtils'

const CartItemDuration = ({ duration, isOnlineResource, isSubscription }) => {
  const isOnlineResourcePerpetual = duration === PERPETUAL && isOnlineResource
  const isShowingDuration = !isOnlineResourcePerpetual && !isSubscription

  return (
    <If condition={isShowingDuration}>
      <p>
        <FormattedMessage id='carts.duration' />
        {durationText(duration)}
      </p>
    </If>
  )
}

CartItemDuration.propTypes = {
  duration: PropTypes.string.isRequired,
  isOnlineResource: PropTypes.bool.isRequired,
  isSubscription: PropTypes.bool.isRequired
}

export default CartItemDuration
